import zh from '../../resources/locales/zh-CN.json';
import warehouse from './zh-CN/warehouse';
export default {
  ...zh,
  ...warehouse,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['zh-CN'],
};
